var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 119,
    viewBox: "0 0 186 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5906 101.796H66.8364V117.56H62.2642V101.796H55.5469V98.0995H73.5906V101.796Z",
    fill: "#282727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1638 106.568L0 97.2133V117.56H4.57214V106.414L11.1638 111.937L17.7577 106.414V117.56H22.3298V97.2133L11.1638 106.568Z",
    fill: "#282727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.508 98.0995V117.56H120.628V113.864H110.041V98.0995H105.508Z",
    fill: "#282727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.879 98.0995V117.56H127.307V98.0995H131.879Z",
    fill: "#282727"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0712 101.796V98.0995H30.8281V117.56H49.0712V113.864H35.4003V109.575H47.0473V106.085H35.4003V101.796H49.0712Z",
    fill: "#282727"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.979 101.796V98.0995H167.738V117.56H185.979V113.864H172.308V109.575H183.955V106.085H172.308V101.796H185.979Z",
    fill: "#282727"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2213 97.2133L75.6133 117.56H80.8615L87.2213 106.392L93.5811 117.56H98.8294L87.2213 97.2133Z",
    fill: "#282727"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.962 118.447L138.354 98.0995H143.6L149.962 109.268L156.321 98.0995H161.57L149.962 118.447Z",
    fill: "#282727"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.124 66.8356H118.031L99.9351 35.4937L106.535 24.0612L128.402 61.9319H142.291L106.535 0L92.9903 23.4631L79.4428 0L33.9121 78.864H74.8967L90.156 52.4323L83.2089 40.4039L67.9496 66.8356H54.7468L79.4428 24.0612L111.084 78.864H152.068L145.124 66.8356Z",
    fill: "url(#paint0_linear_1280_20009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1280_20009",
    x1: 92.9902,
    y1: 77.9321,
    x2: 92.9902,
    y2: 0.75087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F1985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3007F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.535232cbf7db1092fcfdb5a7085c2202.svg";
export { ForwardRef as ReactComponent };